export default __webpack_public_path__ + "static/media/neutropenia_febril.d9a7d289.pdf";